const channelKeys = {
    all: () => [{ entity: 'episode' }],
    allLists: () => [{ ...channelKeys.all()[0], scope: 'list' }],
    allDetails: () => [{ ...channelKeys.all()[0], scope: 'detail' }],
};

export default channelKeys;
